const ThirtyEightDegreesLogo = ({ colour }: { colour: string }) => {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 1441.8 304"
      xmlSpace="preserve"
      fill={colour} // Set the fill color based on the 'color' prop
    >
      <g>
        <g>
          <path
            d="M0.5,168.9h45.3c2.1,19.6,15.7,29,35.3,29c17.5,0,29.3-9.7,29.6-23.5c0.3-15.4-12.4-26-31.7-26H60.3v-36.5
			h16.3c19,0,27.8-9.7,28.1-23.2c0.3-13-10.6-22-24.4-22C62.1,66.6,50,79,50.3,93.4H4.7c0-45.6,38-71.8,75.4-71.8
			c45.9,0,70.3,29.6,70.3,63.1c0,20.8-11.2,37.4-22.3,46.2c14.5,6.9,28.4,23.2,28.4,47.4c0,37.7-30.2,64.6-75.4,64.6
			C41.2,242.8,2.3,218.1,0.5,168.9z"
          />
          <path
            d="M180.9,173.4c0-23.2,9.4-40.1,25.6-50.4c-11.2-10.6-17.2-25.3-17.2-42.5c0-33.8,27.2-58.8,68.8-58.8
			s68.8,25,68.8,58.8c0,17.2-6,31.7-17.5,42.5c16.6,10.3,25.9,27.2,25.9,50.4c0,40.7-33.8,69.4-77.2,69.4
			C214.7,242.8,180.9,214.1,180.9,173.4z M288.4,172.2c0-14.5-11.2-28.7-30.2-28.7c-19.3,0-30.2,14.2-30.2,28.7
			c0,14.5,10.9,28.7,30.2,28.7C277.2,200.9,288.4,186.7,288.4,172.2z M282.9,84.7c0-13.3-10.9-22.9-24.7-22.9
			c-13.9,0-24.7,9.7-24.7,22.9c0,13.3,10.9,22.9,24.7,22.9C272.1,107.6,282.9,98,282.9,84.7z"
          />
          <path
            d="M365.5,25.3h73c60.3,0,109.2,47.7,109.2,107.1s-48.9,107.1-109.2,107.1h-73V25.3z M438.5,195.4
			c36.2,0,60.6-28.7,60.6-63.1c0-34.4-24.4-63.1-60.6-63.1h-25v126.1H438.5z"
          />
          <path
            d="M567.3,171.7c0-40.5,30.8-70.2,71.6-70.2c38.9,0,73.8,26.5,72.1,80H607c1.9,13.8,12.2,25.9,34,25.9
			c11.9,0,22.7-5.4,25.9-12.7h42.7c-8.6,28.1-36.7,47.8-70.8,47.8C597,242.5,567.3,212.7,567.3,171.7z M608.1,155.5h57.8
			c-4.3-16.2-17.6-21.6-28.1-21.6C621.6,133.9,611.6,143,608.1,155.5z"
          />
          <path
            d="M734.2,246.8h39.7c4.3,12.7,13.5,18.1,27.3,18.1c14,0,27-8.6,27-27.8v-15.9c-6.2,9.2-20.3,16.5-36.7,16.5
			c-34.6,0-63.2-30.3-63.2-68.1s28.6-68.1,63.2-68.1c16.5,0,30.5,7.3,36.7,16.5v-13.5H869v126.7c0,50-34,67.5-68.9,67.5
			C761.5,298.7,736.4,276,734.2,246.8z M831.5,169.5c0-18.9-14.6-31.1-31.1-31.1c-16.5,0-31.1,12.2-31.1,31.1
			c0,18.9,14.6,31.1,31.1,31.1C816.9,200.6,831.5,188.4,831.5,169.5z"
          />
          <path
            d="M902.5,104.4h40.8v20.3c4.3-11.9,17.3-21.9,32.2-21.9c4.1,0,8.4,0.3,13.2,1.6v41.3
			c-6.2-2.2-11.6-3.2-18.1-3.2c-17.6,0-27.3,13.5-27.3,33v64h-40.8V104.4z"
          />
          <path
            d="M998.5,171.7c0-40.5,30.8-70.2,71.6-70.2c38.9,0,73.8,26.5,72.1,80h-104c1.9,13.8,12.2,25.9,34,25.9
			c11.9,0,22.7-5.4,25.9-12.7h42.7c-8.6,28.1-36.7,47.8-70.8,47.8C1028.2,242.5,998.5,212.7,998.5,171.7z M1039.2,155.5h57.8
			c-4.3-16.2-17.6-21.6-28.1-21.6C1052.8,133.9,1042.8,143,1039.2,155.5z"
          />
          <path
            d="M1159.5,171.7c0-40.5,30.8-70.2,71.6-70.2c38.9,0,73.8,26.5,72.1,80h-104c1.9,13.8,12.2,25.9,34,25.9
			c11.9,0,22.7-5.4,25.9-12.7h42.7c-8.6,28.1-36.7,47.8-70.8,47.8C1189.2,242.5,1159.5,212.7,1159.5,171.7z M1200.3,155.5h57.8
			c-4.3-16.2-17.6-21.6-28.1-21.6C1213.8,133.9,1203.8,143,1200.3,155.5z"
          />
          <path
            d="M1320.2,195.5h43c0.5,10.8,9.7,16.2,21.3,16.2c10.5,0,15.1-3.8,15.1-8.6c0-5.9-4.9-8.6-15.4-11.3l-27.3-7
			c-23.5-5.9-34-22.4-34-42.4c0-23.5,20.8-40.8,56.5-40.8c29.7,0,54,15.1,55.9,43.8h-41.1c-1.6-10-8.6-12.4-15.7-12.4
			c-8.4,0-13.8,3.2-13.8,8.6c0,7,7.6,8.9,13.8,10.5l24.6,6.5c27.3,7.3,38.1,21.1,38.1,42.4c0,25.1-24,41.6-58.1,41.6
			C1346.4,242.5,1321.6,221.9,1320.2,195.5z"
          />
        </g>
        <g>
          <path
            d="M571.7,26.4h12.7v4.2c1.7-2.3,5.8-5.1,11.4-5.1c11,0,19.5,10,19.5,21.9c0,11.9-8.5,22-19.5,22
			c-5.6,0-9.8-2.9-11.4-5.1V86h-12.7V26.4z M602.5,47.4c0-6.1-3.9-10.4-9.6-10.4c-5.7,0-9.6,4.4-9.6,10.4c0,6.1,3.9,10.4,9.6,10.4
			C598.6,57.8,602.5,53.5,602.5,47.4z"
          />
          <path
            d="M620.7,47.3c0-12.6,9.6-21.9,22.3-21.9c12.1,0,23,8.2,22.5,24.9H633c0.6,4.3,3.8,8.1,10.6,8.1
			c3.7,0,7.1-1.7,8.1-4H665c-2.7,8.7-11.4,14.9-22,14.9C629.9,69.4,620.7,60.1,620.7,47.3z M633.4,42.3h18c-1.3-5-5.5-6.7-8.7-6.7
			C637.6,35.6,634.5,38.4,633.4,42.3z"
          />
          <path
            d="M670.7,47.4c0-12.4,10-21.9,22.1-21.9C705,25.5,715,35,715,47.4c0,12.4-10,22-22.1,22
			C680.7,69.4,670.7,59.8,670.7,47.4z M702.2,47.4c0-6-4-10.1-9.3-10.1c-5.3,0-9.3,4.1-9.3,10.1c0,6,4,10.1,9.3,10.1
			C698.1,57.5,702.2,53.4,702.2,47.4z"
          />
          <path
            d="M722.8,26.4h12.7v4.2c1.7-2.3,5.8-5.1,11.4-5.1c11,0,19.5,10,19.5,21.9c0,11.9-8.5,22-19.5,22
			c-5.6,0-9.8-2.9-11.4-5.1V86h-12.7V26.4z M753.7,47.4c0-6.1-3.9-10.4-9.6-10.4c-5.7,0-9.6,4.4-9.6,10.4c0,6.1,3.9,10.4,9.6,10.4
			C749.8,57.8,753.7,53.5,753.7,47.4z"
          />
          <path d="M774.3,5.4H787v63.1h-12.7V5.4z" />
          <path
            d="M794.9,47.3c0-12.6,9.6-21.9,22.3-21.9c12.1,0,23,8.2,22.5,24.9h-32.4c0.6,4.3,3.8,8.1,10.6,8.1
			c3.7,0,7.1-1.7,8.1-4h13.3c-2.7,8.7-11.4,14.9-22,14.9C804.2,69.4,794.9,60.1,794.9,47.3z M807.6,42.3h18c-1.3-5-5.5-6.7-8.7-6.7
			C811.9,35.6,808.7,38.4,807.6,42.3z"
          />
          <path
            d="M866.5,26.4h12.7v4.2c1.7-2.3,5.8-5.1,11.4-5.1c11,0,19.5,10,19.5,21.9c0,11.9-8.5,22-19.5,22
			c-5.6,0-9.8-2.9-11.4-5.1V86h-12.7V26.4z M897.4,47.4c0-6.1-3.9-10.4-9.6-10.4c-5.7,0-9.6,4.4-9.6,10.4c0,6.1,3.9,10.4,9.6,10.4
			C893.5,57.8,897.4,53.5,897.4,47.4z"
          />
          <path
            d="M915.5,47.4c0-12.4,10-21.9,22.1-21.9c12.1,0,22.1,9.6,22.1,21.9c0,12.4-10,22-22.1,22
			C925.5,69.4,915.5,59.8,915.5,47.4z M946.9,47.4c0-6-4-10.1-9.3-10.1c-5.3,0-9.3,4.1-9.3,10.1c0,6,4,10.1,9.3,10.1
			C942.9,57.5,946.9,53.4,946.9,47.4z"
          />
          <path
            d="M995.7,46.2l-7.2,22.3h-12.8l-13.9-42h13.6l7.3,25.7l8-25.7h9.8l8,25.7l7.3-25.7h13.6l-13.8,42h-12.8
			L995.7,46.2z"
          />
          <path
            d="M1031.6,47.3c0-12.6,9.6-21.9,22.3-21.9c12.1,0,23,8.2,22.5,24.9H1044c0.6,4.3,3.8,8.1,10.6,8.1
			c3.7,0,7.1-1.7,8.1-4h13.3c-2.7,8.7-11.4,14.9-22,14.9C1040.9,69.4,1031.6,60.1,1031.6,47.3z M1044.3,42.3h18
			c-1.3-5-5.5-6.7-8.7-6.7C1048.5,35.6,1045.4,38.4,1044.3,42.3z"
          />
          <path
            d="M1084.3,26.4h12.7v6.3c1.3-3.7,5.4-6.8,10-6.8c1.3,0,2.6,0.1,4.1,0.5v12.9c-1.9-0.7-3.6-1-5.6-1
			c-5.5,0-8.5,4.2-8.5,10.3v19.9h-12.7V26.4z"
          />
          <path
            d="M1132.8,47.4c0-12.2,9.3-21.9,22.1-21.9c11.9,0,19.4,7.5,21.7,17.3h-13.1c-1.5-3.4-4.1-5.9-8.6-5.9
			c-5.3,0-9.3,4-9.3,10.5c0,6.6,4,10.5,9.3,10.5c4.5,0,7.1-2.5,8.6-5.9h13.1c-2.3,9.8-9.8,17.3-21.7,17.3
			C1142.1,69.4,1132.8,59.6,1132.8,47.4z"
          />
          <path
            d="M1183.9,5.4h12.7v25.3c2-2.9,6.2-5.2,11.7-5.2c10.3,0,16.3,7.7,16.3,18.7v24.3h-12.7V46.3
			c0-5.8-2.3-9.3-6.8-9.3c-4.8,0-8.5,3.4-8.5,11v20.4h-12.7V5.4z"
          />
          <path
            d="M1232,47.4c0-11.9,8.5-21.9,19.5-21.9c5.6,0,9.8,2.9,11.4,5.1v-4.2h12.7v42H1263v-4.2
			c-1.7,2.3-5.8,5.1-11.4,5.1C1240.5,69.4,1232,59.4,1232,47.4z M1264,47.4c0-6.1-3.9-10.4-9.6-10.4c-5.7,0-9.6,4.4-9.6,10.4
			c0,6.1,3.9,10.4,9.6,10.4C1260.1,57.8,1264,53.5,1264,47.4z"
          />
          <path
            d="M1286.1,26.4h12.7v4.3c2-2.9,6.2-5.2,11.7-5.2c10.3,0,16.3,7.7,16.3,18.7v24.3h-12.7V46.3
			c0-5.8-2.3-9.3-6.8-9.3c-4.8,0-8.5,3.4-8.5,11v20.4h-12.7V26.4z"
          />
          <path
            d="M1336.1,70.7h12.4c1.3,4,4.2,5.6,8.5,5.6c4.4,0,8.4-2.7,8.4-8.7v-5c-1.9,2.9-6.3,5.1-11.4,5.1
			c-10.8,0-19.7-9.4-19.7-21.2s8.9-21.2,19.7-21.2c5.1,0,9.5,2.3,11.4,5.1v-4.2h12.7v39.4c0,15.6-10.6,21-21.4,21
			C1344.6,86.9,1336.7,79.8,1336.1,70.7z M1366.4,46.7c0-5.9-4.5-9.7-9.7-9.7s-9.7,3.8-9.7,9.7c0,5.9,4.5,9.7,9.7,9.7
			S1366.4,52.5,1366.4,46.7z"
          />
          <path
            d="M1385.9,47.3c0-12.6,9.6-21.9,22.3-21.9c12.1,0,23,8.2,22.5,24.9h-32.4c0.6,4.3,3.8,8.1,10.6,8.1
			c3.7,0,7.1-1.7,8.1-4h13.3c-2.7,8.7-11.4,14.9-22,14.9C1395.2,69.4,1385.9,60.1,1385.9,47.3z M1398.6,42.3h18
			c-1.3-5-5.5-6.7-8.7-6.7C1402.9,35.6,1399.7,38.4,1398.6,42.3z"
          />
        </g>
      </g>
    </svg>
  );
};

export default ThirtyEightDegreesLogo;
